import React from 'react';
import { Features } from '../components/Features';
import { Contact } from '../components/Contact';
import { Button } from '../components/Button';
import { ArrowRight, MessageSquare } from 'lucide-react';
import { PageHeader } from '../components/PageHeader';

export const Services: React.FC = () => {
  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="animate-fade-in-up">
      <PageHeader title="Unsere//Leistungen" subtitle="Angebote" />
      
      {/* Removed negative margin to fix text overlap bug */}
      <div>
        <Features />
      </div>
      
      {/* Custom Pricing / On Request Section */}
      <section className="py-20 bg-brand-gray">
        <div className="max-w-4xl mx-auto px-4 text-center flex flex-col items-center">
           <div className="inline-block p-4 rounded-full bg-white shadow-lg mb-6 text-brand-orange animate-bounce">
              <MessageSquare size={32} />
           </div>
           <h2 className="text-4xl font-black text-brand-dark mb-6 uppercase tracking-tight text-center">
             Preise auf Anfrage.
           </h2>
           <p className="text-xl text-gray-600 mb-10 leading-relaxed font-medium text-center">
             Jedes Unternehmen ist anders. Wir schnüren Pakete, die genau auf deine Ziele und dein Budget passen. 
             Keine Standards, sondern maximale Performance für dein Geld.
           </p>
           
           {/* Strictly Centered Button Container */}
           <div className="w-full flex justify-center">
               <Button onClick={scrollToContact} variant="primary" className="text-lg px-10 py-4 shadow-xl shadow-orange-500/20">
                 Jetzt Angebot anfordern <ArrowRight className="ml-2" size={20} />
               </Button>
           </div>
        </div>
      </section>

      <Contact />
    </div>
  );
};